import { ProfileOutlined } from "@ant-design/icons";
import * as React from "react";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { getWorkflowDisplayName } from "src/business/workflow/getWorkflowDisplayName";
import {
  workflowDestinations,
  ZWorkflow,
} from "src/business/workflow/ZWorkflow";
import { BlankLink } from "src/components/BlankLink";
import { makeMdmActionColumn, RenderLinkAction } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const createWorkflowColumns = (): RtColumn<ZWorkflow>[] => [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    render: ({ name }) => name,
  },
  {
    key: "displayName",
    title: "Отображаемое название",
    render: (row) => getWorkflowDisplayName(row),
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description ?? "",
  },
  {
    key: "catalog",
    title: "Каталог",
    render: ({ catalog }) =>
      catalog ? (
        <BlankLink
          href={makeUrl(PageUrl.managementCatalogEdit, { id: catalog.id })}
        >
          {catalog.label}
        </BlankLink>
      ) : (
        ""
      ),
  },
  {
    key: "destination",
    title: "Назначение",
    render: ({ destination }) =>
      (destination && workflowDestinations[destination]) ?? "",
  },
  {
    key: "owner",
    title: "Владелец потока",
    render: ({ owner }) => owner?.label ?? "",
  },
  ...sysColumnsHistory,
  makeMdmActionColumn<ZWorkflow>({
    key: "cards",
    render: ({ id }) => (
      <RenderLinkAction
        icon={<ProfileOutlined />}
        tooltip="Открыть список в новой вкладке"
        href={makeUrl(PageUrl.workflowCards, { id })}
      />
    ),
  }),
];
